"use client";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";
import { valuesData } from "@/lib/about-data";
import { containerVariants, itemVariants } from "@/utils/animations";

export default function CoreValues() {
  return (
    <section className="py-24 px-6 max-w-[83.75rem] mx-auto">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        className="grid grid-cols-1 lg:grid-cols-3 gap-8"
      >
        {valuesData.map((val, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className={`p-10 rounded-3xl border flex flex-col justify-center transition-all duration-300 ${
              index === 1
                ? "bg-midnight dark:bg-white/5 border-midnight dark:border-white/10 shadow-2xl scale-105 z-10"
                : "bg-white dark:bg-transparent border-border dark:border-white/10 hover:border-primary/30"
            }`}
          >
            <div
              className={`mb-6 ${index === 1 ? "text-green" : "text-primary"}`}
            >
              <Icon icon={val.icon} width="48" />
            </div>
            <h3
              className={`text-24 font-bold mb-4 ${
                index === 1
                  ? "text-primary"
                  : "text-midnight_text dark:text-white"
              }`}
            >
              {val.title}
            </h3>
            <p
              className={`${
                index === 1 ? "text-muted/80" : "text-muted dark:text-white/60"
              } leading-relaxed`}
            >
              {val.desc}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
